export default __webpack_public_path__ + "static/media/yellow.bf8d9531.svg";